import React from 'react'

import "./Top.css"
import { Container, Col,Row, ListGroup, Nav } from 'react-bootstrap'
const Top = () => {
  return (
  
<div className='mb-3'>
    <div className='top-container py-2 mb-6 ' fluid>

<div className=''>Team Members</div>
    </div>

    </div>
  )
}

export default Top